import React from 'react';

import Upload from './Upload';
import List from './List';

import { Container, Content } from './styles';

import { CustomProjectFileProvider } from '~/context/customprojectfiles';

interface IUploadCustomProjectFilesProps {
  type: string;
  project_custom_proj_temp_id: string;
  project_type: string;
  sequence: number;
  user_id: string;
}

const UploadCustomProjectFiles: React.FC<IUploadCustomProjectFilesProps> = ({
  type,
  project_custom_proj_temp_id,
  project_type,
  sequence,
  user_id,
}) => {
  return (
    <CustomProjectFileProvider>
      <Container>
        <Content>
          <Upload
            type={type}
            project_custom_proj_temp_id={project_custom_proj_temp_id}
            project_type={project_type}
            sequence={sequence}
            user_id={user_id}
          />
          <List />
        </Content>
      </Container>
    </CustomProjectFileProvider>
  );
};

export default UploadCustomProjectFiles;
